import { CButton, CCard } from '@coreui/react'
import useAxios from 'axios-hooks'
import React, { useContext, useEffect, useState } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { CustomDescriptionBox } from 'src/components'
import CustomMultiSelect from 'src/components/customMultiSelect/customMultiSelect'
import { AppContext } from 'src/views/context/app'
import { activeArray, raiseToast } from 'src/views/utils/helper'
import {
  EMAIL_TEMPLATES_API,
  Mail_Template_CUSTOM_META_DATA_API,
  USER_API,
} from 'src/views/utils/urls'
import CustomMetadata from 'src/components/CustomMetadata/CustomMetadata'
import { isEmpty } from 'lodash'
import EmailModal from './emailModal'
import HTMl_IMAGE from '../../../../assets/computer-img.png'

const CreateCampaignEmailTemplate = () => {
  const [createFlag, setCreateFlag] = useState(false)
  const { mailTemplateId } = useParams()
  const location = useLocation()
  const history = useHistory()
  const { setLoader } = useContext(AppContext)
  const isEdit = location.pathname.includes('/campaign/mail-templates/edit')

  const [templateName, setTemplateName] = useState('')
  const [templateBody, setTemplateBody] = useState('')
  const [templateSubject, setTemplateSubject] = useState('')
  const [description, setDescription] = useState('')

  const [customMetadata, setCustomMetadata] = useState({})

  const [cmsUserMaster, setCmsUserMaster] = useState([])
  const [userGroupMaster, setUserGroupMaster] = useState([])
  const [cmsUser, setCmsUser] = useState([])
  const [userGroup, setUserGroup] = useState([])

  const [errorData, setErrorData] = useState({})

  const [
    { data: emailTemplateCreate, loading: emailTemplateCreateLoading },
    emailTemplateCreateCall,
  ] = useAxios(
    {
      url: EMAIL_TEMPLATES_API,
      method: 'post',
    },
    { manual: true },
  )

  const [
    { data: emailTemplateUpdate, loading: emailTemplateUpdateLoading },
    emailTemplateUpdateCall,
  ] = useAxios(
    {
      url: EMAIL_TEMPLATES_API,
      method: 'put',
    },
    { manual: true },
  )

  const [{ data: emailTemplateData, loading: emailTemplateDataLoading }, emailTemplateDataCall] =
    useAxios(
      {
        url: EMAIL_TEMPLATES_API,
        method: 'get',
      },
      { manual: true },
    )

  const [{ data: cmsUserList, loading: cmsUserListLoading }, cmsUserListCall] = useAxios(
    {
      url: `${USER_API}/cms-user`,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: userGroupList, loading: userGroupListLoading }, userGroupListCall] = useAxios(
    {
      url: `${USER_API}/user-group`,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: customMetadataList, loading: customMetadataLoading }, customMetadataCall] =
    useAxios(
      {
        url: Mail_Template_CUSTOM_META_DATA_API,
        method: 'get',
      },
      { manual: true },
    )

  useEffect(() => {
    if (isEdit && mailTemplateId) {
      emailTemplateDataCall({
        params: {
          email_template_id: mailTemplateId,
        },
      })
    }
  }, [location])

  useEffect(async () => {
    customMetadataCall()
    userGroupListCall()
    cmsUserListCall()
  }, [])

  useEffect(() => {
    setLoader(
      emailTemplateDataLoading ||
        cmsUserListLoading ||
        userGroupListLoading ||
        customMetadataLoading ||
        emailTemplateUpdateLoading ||
        emailTemplateCreateLoading,
    )
  }, [
    emailTemplateDataLoading,
    emailTemplateDataLoading,
    cmsUserListLoading,
    userGroupListLoading,
    customMetadataLoading,
    emailTemplateCreateLoading,
    emailTemplateUpdateLoading,
  ])

  useEffect(() => {
    if (
      emailTemplateData &&
      emailTemplateData.success &&
      !isEmpty(cmsUserMaster) &&
      !isEmpty(userGroupMaster)
    ) {
      setTemplateName(emailTemplateData?.data?.name)
      setDescription(emailTemplateData?.data?.description || '')
      setTemplateBody(emailTemplateData?.data?.body)
      setTemplateSubject(emailTemplateData?.data?.subject)
      setCustomMetadata(emailTemplateData?.data?.custom_metadata)

      if (!isEmpty(emailTemplateData?.data?.cms_users)) {
        let data = emailTemplateData?.data?.cms_users
        let tempArr = []
        for (let i = 0; i < data.length; i++) {
          const id = data[i]

          let obj = cmsUserMaster.find((info) => info._id === id)
          if (obj) {
            tempArr.push(obj)
          }
        }

        setCmsUser([...tempArr])
      }
      if (!isEmpty(emailTemplateData?.data?.user_groups)) {
        let data = emailTemplateData?.data?.user_groups
        let tempArr = []
        for (let i = 0; i < data.length; i++) {
          const id = data[i]
          let obj = userGroupMaster.find((info) => info._id === id)
          if (obj) {
            tempArr.push(obj)
          }
        }

        setUserGroup([...tempArr])
      }
    }
  }, [emailTemplateData, cmsUserMaster, userGroupMaster])

  useEffect(() => {
    if (emailTemplateCreate && emailTemplateCreate.success) {
      raiseToast('success', 'Template Created Successfully')
      history.push(`/campaign/mail-templates/list`)
    }
  }, [emailTemplateCreate])

  useEffect(async () => {
    if (emailTemplateUpdate && emailTemplateUpdate.success) {
      raiseToast('success', 'Template Updated Successfully!')
      history.push(`/campaign/mail-templates/list`)
    }
  }, [emailTemplateUpdate])

  useEffect(() => {
    if (userGroupList && userGroupList.success) {
      setUserGroupMaster(userGroupList.data)
    }
  }, [userGroupList])

  useEffect(() => {
    if (cmsUserList && cmsUserList.success) {
      setCmsUserMaster(cmsUserList.data)
    }
  }, [cmsUserList])

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (templateName.trim().length === 0) {
      isFormValid = false
      temp.templateName = 'Template name cannot be empty!'
    }

    if (templateSubject.trim().length === 0) {
      isFormValid = false
      temp.templateSubject = 'Template subject cannot be empty!'
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  const handleCreate = () => {
    if (!validateInfo()) return

    emailTemplateCreateCall({
      data: {
        name: templateName,
        description: description,
        template_type: 'CUSTOM',
        cms_users: cmsUser.map((info) => info._id),
        user_groups: userGroup.map((info) => info._id),
        custom_metadata: customMetadata,
        body: templateBody,
        subject: templateSubject,
        is_system_defined: false,
      },
    })
  }

  const handleUpdate = () => {
    emailTemplateUpdateCall({
      params: {
        email_template_id: mailTemplateId,
      },
      data: {
        name: templateName,
        description: description,
        template_type: 'CUSTOM',
        cms_users: cmsUser.map((info) => info._id),
        user_groups: userGroup.map((info) => info._id),
        custom_metadata: customMetadata,
        body: templateBody,
        subject: templateSubject,
        is_system_defined: false,
      },
    })
  }

  const handleTemplateCreation = () => {
    console.log('clicked html')
    setCreateFlag(true)
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mt-4">
        {createFlag && (
          <EmailModal
            body={templateBody}
            handleChange={setTemplateBody}
            handleClose={setCreateFlag}
          />
        )}
        <div>
          <h4>Email Template</h4>
          <p>Following are the Email Templates which are already in your store.</p>
        </div>
      </div>
      <CCard
        style={{
          height: '68vh',
          overflowX: 'hidden',
          paddingLeft: '2.135vw',
          paddingRight: '2.135vw',
          paddingTop: '2.5vw',
        }}
        className="custom-scrollbar-vertical "
      >
        <div className="w-100">
          <div
            style={{ background: '#e2e2e2', fontWeight: '550', fontSize: '0.8333vw' }}
            className="w-100 rounded pl-4"
          >
            Basic Properties
          </div>
          <div
            className="w-100 pl-4 pr-1 d-flex justify-content-between "
            style={{ marginTop: '1.355vw' }}
          >
            <div style={{ width: '45%' }}>
              <div>
                <h6 style={{ fontSize: '.8333vw' }}>
                  Template Name <span style={{ color: 'red' }}>*</span>
                </h6>
                <CustomDescriptionBox
                  limit={50}
                  rows={1}
                  value={templateName}
                  onChange={(value) => {
                    setTemplateName(value)
                  }}
                  isMandatory={true}
                  errorText={errorData[`templateName`]}
                  style={{ fontSize: '13px' }}
                  useFormInput={true}
                />
              </div>

              <div>
                <h6 style={{ fontSize: '.8333vw' }}>Description</h6>
                <CustomDescriptionBox
                  limit={150}
                  rows={2}
                  value={description}
                  onChange={(value) => {
                    setDescription(value)
                  }}
                  isMandatory={true}
                  errorText={errorData[`description`]}
                  style={{ fontSize: '13px' }}
                />
              </div>
              <div>
                <h6 style={{ fontSize: '.8333vw' }}>
                  Subject <span style={{ color: 'red' }}>*</span>
                </h6>
                <CustomDescriptionBox
                  limit={50}
                  rows={1}
                  value={templateSubject}
                  onChange={(value) => {
                    setTemplateSubject(value)
                  }}
                  isMandatory={true}
                  errorText={errorData[`audienceName`]}
                  style={{ fontSize: '13px' }}
                  useFormInput={true}
                />
              </div>
            </div>
            <div style={{ width: '53%' }} className="h-100">
              <div style={{ paddingTop: '20px' }} className=" h-100">
                <img src={HTMl_IMAGE} className="w-100 h-100" alt={'img'} />
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    paddingTop: '14px',
                    paddingBottom: '14px',
                    background: '#eeeeee',
                    borderBottomRightRadius: '5px',
                    borderBottomLeftRadius: '5px',
                  }}
                >
                  <CButton
                    className="text-white px-3"
                    onClick={handleTemplateCreation}
                    style={{
                      pointerEvents: 'auto',
                      fontSize: '12px',
                      background: '#20211c',
                    }}
                  >
                    {'</> Open HTML Editor'}
                  </CButton>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="w-100 mt-4 ">
          <div
            style={{ background: '#e2e2e2', fontWeight: '550', fontSize: '0.8333vw' }}
            className="w-100 rounded pl-4"
          >
            Visibility and Permissions
          </div>
          <div
            className=" pl-4 pr-1 d-flex justify-content-between "
            style={{ marginTop: '1.355vw', width: '65%' }}
          >
            <div style={{ width: '45%' }} className="">
              <h6 style={{ fontSize: '.8333vw' }}>CMS Users</h6>
              <CustomMultiSelect
                selectedValue={cmsUser}
                optionsData={cmsUserMaster}
                onChange={setCmsUser}
                labelKey="name"
              />
            </div>
            <div style={{ width: '45%' }} className="">
              <h6 style={{ fontSize: '.8333vw' }}>CMS User Groups</h6>
              <CustomMultiSelect
                selectedValue={userGroup}
                optionsData={userGroupMaster}
                onChange={setUserGroup}
                labelKey="name"
              />
            </div>
          </div>
        </div>
        <div className="w-100 mt-4 pb-5">
          <div
            style={{ background: '#e2e2e2', fontWeight: '550', fontSize: '0.8333vw' }}
            className="w-100 rounded pl-4"
          >
            Custom Properties
          </div>
          <div
            className="w-100 pl-4 pr-1 d-flex justify-content-between "
            style={{ marginTop: '0.3vw' }}
          >
            {customMetadataList && !isEmpty(customMetadataList?.data) && (
              <CustomMetadata
                isEdit={isEdit}
                editData={isEdit ? { custom_metadata: customMetadata } : {}}
                customMetadataMaster={activeArray(customMetadataList.data)}
                customPayload={customMetadata}
                setCustomPayload={setCustomMetadata}
                column={3}
              />
            )}
          </div>
        </div>
      </CCard>
      <div className="w-100 d-flex justify-content-end mt-2">
        <CButton
          className="px-3 mx-4 text-black border"
          onClick={() => {
            history.push(`/campaign/mail-templates/list`)
          }}
          style={{
            pointerEvents: 'auto',
            fontSize: '18px',
            background: 'inherit',
            border: 'solid 1.5px #bdbdbd',
          }}
        >
          Cancel
        </CButton>
        <CButton
          className="text-white px-3"
          onClick={isEdit ? handleUpdate : handleCreate}
          style={{ pointerEvents: 'auto', fontSize: '18px', background: '#20211c' }}
        >
          Save Template
        </CButton>
      </div>
    </div>
  )
}

export default CreateCampaignEmailTemplate
